(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-kuroco-topics"] && !Shopify.designMode) return;
  try {
    
  /* 1つの記事を変換する処理 */
  function datachange2(subject, imageurl, topics_id) {
    return `<div class='blog__post-item grid__item custom__grid_kuroco'>
    <div>
        <a href='https://kenkatsu.jp/topics/${topics_id}/' class='blog__post-image-link'>
            <div class='blog__post-image'>
                <div class='no-js-image'>
                    <img src='${imageurl}' loading="lazy" width='800' height='600' class='img-object-cover' />
                </div>
            </div>
        </a>
        <div>
            <a class='csm_blog_title' href='https://kenkatsu.jp/topics/{topics_id}/'>${subject}</a>
        </div>
    </div>
</div>`;
  }

  //初期表示処理
  $(document).ready(function () {
    //タグID設定
    var params_tagid = {
      tag_id: $('#tag_id').val(),
      cnt: $('#count').val(),
    };
    //カテID設定
    var params_cateid = {
      contents_type: $('#cate_id').val(),
      cnt: $('#count').val(),
    };

    var params = {};
    var more_url = '';

    if ($('#cate_id').val()) {
      params = params_cateid;
      more_url = `https://kenkatsu.jp/category/${$('#cate_id').val()}`;
    } else if ($('#tag_id').val()) {
      params = params_tagid;
      more_url = `https://kenkatsu.jp/search/?tag=${$('#tag_id').val()}`;
    } else {
      params = params_tagid;
      more_url = `https://kenkatsu.jp/topics/`;
    }

    // ajax通信開始
    $.ajax({
      url: 'https://api.kenkatsu.jp/rcms-api/21/content/list',
      data: params,
      dataType: 'json',
      headers: {
        'x-rcms-api-access-token': '123325df1b6f00476e69856498307e17b374d23f582c624c8797d60d1ad0c5fd',
      },
    }).then(
      // 通信成功時の処理
      function (data) {
        var htmldata = '';
        if (data) {
          var result = data;
          for (const n of result.list) {
            htmldata = htmldata + datachange2(n.subject, n.image.url, n.topics_id);
          }
          $('#kuroco').html(htmldata);

          if (!htmldata) {
            $('#kuroco_header').html('');
          }
        } else {
          $('#kuroco_header').html('');
        }
      },
      // 通信失敗時の処理
      function () {}
    );
  });

  } catch(e) { console.error(e); }
})();
})();
